<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <div class="card card-w-title">
        <div class="manager-title-custom">{{ title }}</div>
        <!-- <div class="note">(*) Nội dung không được bỏ trống</div> -->
        <formEdit
          :key="componentKey"
          :mode="mode"
          @back="backToList"
          @save="saveData"
          :model="models"/>
      </div>
    </div>
  </div>
</template>

<script>
// import Config from '../../../config/index'
import formEdit from './add'
import ApiRepository from "@/core/ApiRepository";
export default {
  components: {
    formEdit
  },
  data() {
    return {
      users: null,
      validationErrors: [],
      title: "Thêm mới Gói Công Việc",
      mode: 'add',
      models: {},
      componentKey: 0,
      accountID: '',
      page_transaction:null,
      company_id: null
    }
  },
  async mounted () {
    // console.log("this.$route.name:",this.$route.query.page_transaction);
    this.mode = this.$route.name === 'editSra' ? 'edit' : this.mode;
    this.title = this.mode === 'edit' ? 'Chỉnh sửa Gói Công Việc' : this.title;
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)){
        this.page_transaction = this.$route.query.page_transaction;
      }
      if (!this.$commonFuction.isEmpty(this.$route.query.company_id)){
        this.company_id = this.$route.query.company_id;
      }
    }
    if (this.$route.params.id !== undefined) await this.getData(this.$route.params.id);
    //check quyền
    // var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_BANNER);
    // if (this.mode == 'edit'){
    //   if (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0){
    //     this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
    //   }
    // }else {
    //   if (arr_role.indexOf(this.$constants.ROLE.ADD) < 0){
    //     this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
    //   }
    // }
  },
  methods: {
    backToList() {
      this.$router.push({ path: '/admin/list-sra', query: {company_id: this.company_id} });
    },
    async saveData(params) {
      console.log("params",params)
      var that = this;
      var files = params?.files ?? [];
      var filesDeletes = params?.filesDeletes ?? [];
      var files_work_permit = params?.files_work_permit ?? [];
      var filesDeletesWorkPermit = params?.filesDeletesWorkPermit ?? [];
      let objects = {
        name: params.name,
        company_id: params?.company ? params.company.id : null,
        factory: params?.factory ?? null,//nhà máy
        areas: params?.areas,//khu vực
        description : params?.description,
        date_start : params?.date_start,//ngày
        date_end : params?.date_end,//ngày
        supervisors : params?.supervisors,//giám sát
        contractor : params?.contractor,//nhà thầu
        zone_id : params?.zone?.id ?? params?.contractor?.zone?.id ?? params?.contractor?.zone_id ?? null,
        users1 : params?.users1,//duyệt 1
        users2 : params?.users2,//duyệt 2
        list_danger : params?.list_danger,
        control_measures_text : params?.control_measures_text,
        yc_contractor : params?.yc_contractor,
        yc_personnel : params?.yc_personnel,
        yc_supplies : params?.yc_supplies,
        yc_equipment : params?.yc_equipment,
        list_course : params?.list_course,
        risk_level: params?.risk_level_sel?.value ?? null,
        request_nv: params?.request_nv ?? 0,
      }
      
      this.company_id = params?.company ? params.company.id : null;
      var token = that.$store.getters.token ? that.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        if (this.mode == 'add') {
          await ApiRepository.post("/_api/sra/create", objects, {headers}).then(async function (response) {
            if (response.status === 200) {
                await that.saveFiles(response.data.data?.id, files, filesDeletes, headers);
                await that.saveFiles(response.data.data?.id, files_work_permit, filesDeletesWorkPermit, headers, that.$constants.TYPE_IMAGE.WORK_PERMIT_FILE, that.$constants.FOLDER_S3.WORK_PERMIT);
                that.redirectEdit();
            } else {
              that.$toast.add({
                  severity: 'error',
                  summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                  detail: response.data.message,
                  life: 3000
              });
              that.$commonFuction.is_loading(false);
            }
          }).catch((err) => {
            console.log('errorerrorerrorerror', err);
            that.$toast.add({
                severity: 'error',
                summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: err,
                life: 3000
            });
            that.$commonFuction.is_loading(false);
          })
        } else {
          objects.id = this.$route.params.id;
          await ApiRepository.post("/_api/sra/update", objects, {headers}).then(async function (response) {
            if (response.status === 200) {
              await that.saveFiles(that.$route.params.id, files, filesDeletes, headers);
              await that.saveFiles(that.$route.params.id, files_work_permit, filesDeletesWorkPermit, headers, that.$constants.TYPE_IMAGE.WORK_PERMIT_FILE, that.$constants.FOLDER_S3.WORK_PERMIT);
              that.redirectEdit();
            } else {
              that.$toast.add({ 
                  severity: 'error',
                  summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                  detail: response.data.message,
                  life: 3000
              });
              that.$commonFuction.is_loading(false);
            }
          }).catch((err) => {
            console.log('errorerrorerrorerror', err);
            that.$toast.add({
                severity: 'error',
                summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: err,
                life: 3000
            });
            that.$commonFuction.is_loading(false);
          })
        }
      }
    },
    async saveFiles(sra_id, files, filesDeletes, headers, type, folder) {
      type = type ?? this.$constants.TYPE_IMAGE.CONTROL_MEASURES_FILE;
      folder = folder ?? this.$constants.FOLDER_S3.CONTROL_MEASURES;
      if (!sra_id) return;
      if (filesDeletes && filesDeletes.length > 0) {
        var object_delete = {
          type: type,
          file_ids: filesDeletes
        }
        await ApiRepository.post("/_api/common/delete-s3", object_delete, {headers})
      }
      if (files && files.length > 0) {
        var that = this;
        await Promise.all(files.map(async file => {
          if (file.type !== 'old_edit') {
            const resImage = await that.$CoreService.uploadImages(
              folder,
              [file]
            );
            if (resImage) {
              await that.$CoreService.updateDataImage(
                type,
                sra_id,
                resImage[0]
              );
            }
          }
        }));
      }
    },
    async redirectEdit() {
      var that = this;
      var router_back = {path: '/admin/list-sra'};
      that.$commonFuction.is_loading(false);
      if(that.mode == 'add'){
        router_back.query = {company_id: this.company_id};
        that.$router.push(router_back);
      }else{
        if (!that.$commonFuction.isEmpty(router_back)){
          // that.page_transaction = ""+that.page_transaction
          router_back.query = {company_id: this.company_id };
        }
        that.$router.push(router_back);
      }
      that.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Lưu dữ liệu thành công', life: 3000 })
    },
    async getData(id) {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var {data} = await ApiRepository.post("/_api/sra/detail", {id: id, company_id: this.company_id}, {headers});
        var value = data.data;
        this.models = value;
        this.componentKey++;
      }
    },
  },
  apollo: {
    
  }
}
</script>

<style lang="scss">
  .manager-title-custom{
    color: #1D3118;
    font-size: 18px;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid #EEEEEE;
    font-weight: 700;
  }
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.note{ letter-spacing: 0px; color: #707070; margin-bottom: 24px; padding-top: 10px;}
.p-formgrid { margin: 0;
  .p-panel-header {color: #000000; font-size: 18px; font-weight: bold; background: #EEEEEE;}
  .p-card-field{ padding: 24px;
    .p-field{
      .p-col-fixed { width: 300px; display: inline-block !important; margin: 0;}
      .p-col-width{width:500px !important; border-radius: 5px;
        &.disabled{background: #EEEEEE; border: 0 none; padding: 8px 10px;}
        .file-select{margin: 0;
          input[type="file"]{display: none;}
          .select-button{display: inline-block; cursor: pointer; background: transparent; border-radius: 5px;  color: #000000; font-size: 13px; padding: 3px 16px;  border: 1px solid #B4B4B4;}
        }
        &.pac-target-input{ height: 80px;  word-break: break-all; overflow-wrap: break-word;  resize: none;}
      }
      .box-images{ margin: 0; margin-top: 10px; position: relative;
        .item-img{width: 133px; height: 150px;  margin-right: 8px; margin-bottom: 8px; display: inline-flex; position: relative;
          img{max-width: 100%; height: auto;margin: 0 auto; object-fit: contain; padding: 5px;}
          .button-clear{border-radius: 5px; width: 24px; height: 24px; background: #F5564E; float: right; cursor: pointer; position: absolute; right: 0px;
            img{vertical-align: top;}
          }
        }
      }
      .p-invalid{display: block;}
    }
  }
  .fixed-bottom-toolbar{background: transparent; border: 0 none; margin-top: 22px; border-top: 1px solid #B4B4B4; padding: 0; padding-top: 30px;
    .p-button{width: auto; margin-right: 8px;
      &:last-child{margin-right: 0;}
    }
  }
}
</style>

